import React, { Component } from 'react';

import AppHeader from 'components/AppHeader';
import AppBody   from 'components/AppBody';
import AppFooter from 'components/AppFooter';

class App extends Component {
  render() {
    return (
      <div id="App" className="App  d:f fld:c h:100  lc:dark-pewter  select:n">
        <AppHeader />
        <AppBody />
        <AppFooter />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js